export const ANIMATION_STATE = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
};
export const ANIMATION_CLICK = {
    [ANIMATION_STATE.OPEN]: {
        height: 'auto',
        opacity: 1,
        transition: {
            type: 'spring',
            damping: 10,
            mass: 0.5,
        },
    },
    [ANIMATION_STATE.CLOSED]: {
        height: 0,
        opacity: 0,
        overflow: 'hidden',
        transition: {
            damping: 10,
            mass: 0.5,
        },
    },
};
